/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit AppointmentCard/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Children from 'Simple/Children'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function AppointmentCard({
  children,
  viewPath = "/DesignSystem/AppointmentCard",
  cursor = "auto",
  marginBottom,
  backgroundColor,
  minHeight = "60px",
  width = "100%",
  borderBottomLeftRadius,
  borderBottomRightRadius,
  borderTopLeftRadius,
  borderTopRightRadius,
  borderWidth = 1,
  borderStyle = "solid",
  borderColor,
  overflowX = "initial",
  variant,
  appointmentColor,
  paddingTop,
  paddingBottom,
  paddingLeft,
  paddingRight
  
}) {
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let marginBottomOrdtSpaceXxs = marginBottom ?? dtSpaceXxs
let backgroundColorOrdtColorsWhite = backgroundColor ?? dtColorsWhite
let borderBottomLeftRadiusOrdtSpaceXxs = borderBottomLeftRadius ?? dtSpaceXxs
let borderBottomRightRadiusOrdtSpaceXxs = borderBottomRightRadius ?? dtSpaceXxs
let borderTopLeftRadiusOrdtSpaceXxs = borderTopLeftRadius ?? dtSpaceXxs
let borderTopRightRadiusOrdtSpaceXxs = borderTopRightRadius ?? dtSpaceXxs
let borderColorOrdtColorsNeutral200 = borderColor ?? dtColorsNeutral200
let borderTopLeftRadiusOrdtSpaceXxs1 = borderTopLeftRadius ?? dtSpaceXxs
let borderBottomLeftRadiusOrdtSpaceXxs1 = borderBottomLeftRadius ?? dtSpaceXxs
let dtSpaceXxxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxxs'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtSpaceLs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ls'
        })
let paddingTopOrdtSpaceXs = paddingTop ?? dtSpaceXs
let paddingBottomOrdtSpaceXs = paddingBottom ?? dtSpaceXs
let paddingLeftOrdtSpaceLs = paddingLeft ?? dtSpaceLs
let paddingRightOrdtSpaceLs = paddingRight ?? dtSpaceLs
  return (<React.Fragment
>
<div
  data-testid="AppointmentCard.Vertical"
  data-view-path={viewPath}
 style={{'--c-1-20PYvT': cursor,'--mb-2-20PYvT': typeof marginBottomOrdtSpaceXxs === 'number' ? `${marginBottomOrdtSpaceXxs}px` : marginBottomOrdtSpaceXxs,'--bc-3-20PYvT': backgroundColorOrdtColorsWhite,'--mh-4-20PYvT': typeof minHeight === 'number' ? `${minHeight}px` : minHeight,'--w-5-20PYvT': typeof width === 'number' ? `${width}px` : width,'--bblr-6-20PYvT': typeof borderBottomLeftRadiusOrdtSpaceXxs === 'number' ? `${borderBottomLeftRadiusOrdtSpaceXxs}px` : borderBottomLeftRadiusOrdtSpaceXxs,'--bbrr-7-20PYvT': typeof borderBottomRightRadiusOrdtSpaceXxs === 'number' ? `${borderBottomRightRadiusOrdtSpaceXxs}px` : borderBottomRightRadiusOrdtSpaceXxs,'--btlr-8-20PYvT': typeof borderTopLeftRadiusOrdtSpaceXxs === 'number' ? `${borderTopLeftRadiusOrdtSpaceXxs}px` : borderTopLeftRadiusOrdtSpaceXxs,'--btrr-9-20PYvT': typeof borderTopRightRadiusOrdtSpaceXxs === 'number' ? `${borderTopRightRadiusOrdtSpaceXxs}px` : borderTopRightRadiusOrdtSpaceXxs,'--bw-10-20PYvT': typeof borderWidth === 'number' ? `${borderWidth}px` : borderWidth,'--bs-11-20PYvT': borderStyle,'--bc-12-20PYvT': borderColorOrdtColorsNeutral200,'--ox-13-20PYvT': variant === "skeleton" ? "hidden" : overflowX}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="AppointmentCard.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="AppointmentCard.Vertical:1"
  data-view-path={viewPath}
 style={{'--btlr-8-20PYvT': typeof borderTopLeftRadiusOrdtSpaceXxs1 === 'number' ? `${borderTopLeftRadiusOrdtSpaceXxs1}px` : borderTopLeftRadiusOrdtSpaceXxs1,'--bblr-6-20PYvT': typeof borderBottomLeftRadiusOrdtSpaceXxs1 === 'number' ? `${borderBottomLeftRadiusOrdtSpaceXxs1}px` : borderBottomLeftRadiusOrdtSpaceXxs1,'--bc-3-20PYvT': appointmentColor,'--w-5-20PYvT': variant === "skeleton" ? "0px" : "3px"}}
 className={`views-block ${styles.Vertical1}`}
/>
<div
  data-testid="AppointmentCard.Vertical:2"
  data-view-path={viewPath}
 style={{'--g-14-20PYvT': typeof dtSpaceXxxs === 'number' ? `${dtSpaceXxxs}px` : dtSpaceXxxs,'--pt-15-20PYvT': variant === "skeleton" ? "0px" : typeof paddingTopOrdtSpaceXs === 'number' ? `${paddingTopOrdtSpaceXs}px` : paddingTopOrdtSpaceXs,'--pb-16-20PYvT': variant === "skeleton" ? "0px" : typeof paddingBottomOrdtSpaceXs === 'number' ? `${paddingBottomOrdtSpaceXs}px` : paddingBottomOrdtSpaceXs,'--pl-17-20PYvT': variant === "skeleton" ? "0px" : typeof paddingLeftOrdtSpaceLs === 'number' ? `${paddingLeftOrdtSpaceLs}px` : paddingLeftOrdtSpaceLs,'--pr-18-20PYvT': variant === "skeleton" ? "0px" : typeof paddingRightOrdtSpaceLs === 'number' ? `${paddingRightOrdtSpaceLs}px` : paddingRightOrdtSpaceLs}}
 className={`views-block ${styles.Vertical2}`}
>
<Children
  viewPath={`${viewPath}/Children`}
>
{children}
</Children>
</div>
</div>
</div>
</React.Fragment>)
}